// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"6e0045c8","977":"f49d09dd"}[chunkId] + ".chunk.js";
};